import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//Components
import Layout from 'src/components/common/Layout';
import Wrapper from 'src/components/common/Wrapper';
import SearchForm from 'src/components/common/Search/SearchForm';
import TableHeader from 'src/components/common/Table/TableHeader';
import Loading from 'src/components/common/Loading';
import { useSyles } from 'src/components/common/Wrapper/styles';
import Row from './row.constants';

//Material
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Grid, Button } from '@material-ui/core';
import { Add } from '@material-ui/icons';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { getAllReturns } from 'src/redux/returns/thunks';
import { fieldsFilterList, headCellsLoans, valuesEstatus } from './constants';
import { stableSort } from 'src/helpers/sorts';
import { RolePermissions } from 'src/domain/constants/RolePremissions';
import { SystemActions } from 'src/domain/constants/SystemActions';
import { useAppSelector } from 'src/redux/hooks';
import { RootState } from 'src/domain/models/RootState';

export const ReturnHome = (props: any) => {
  const classes = useSyles();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [firstLoad, setFirstLoad] = useState(true);
  const [filter, setFilter] = useState('');
  const { auth } = useAppSelector((state: RootState) => state);
  const { selectedWarehouse } = useSelector((state: any) => state.warehouses);
  const allowCreate = RolePermissions.allowed(
    Number(auth.type),
    SystemActions.edit_loans
  );
  const allowReadAll = RolePermissions.allowed(
    auth.type,
    SystemActions.edit_loans
  );

  const fieldsFilterListPermision = fieldsFilterList.filter((item) => {
    return item.key !== 'users_id' || allowReadAll;
  });
  const initialValuesFilter = {
    key: allowReadAll ? 'users_id' : fieldsFilterListPermision[0].key,
    name_value: '',
  };
  const { returns, loading } = useSelector((state: any) => state.returns);
  const [pagination, setPagination] = useState({
    rowsPerPage: 10,
    page: 1,
    total: 1,
    order: 'desc',
    orderBy: 'name',
  });

  const updateDataByPagination = async () => {
    await dispatch(getAllReturns({ filter, pagination }));
  };

  useEffect(() => {
    pagination.page = 1;
    updateDataByPagination();
    setFirstLoad(false);
    // eslint-disable-next-line
  }, [filter, selectedWarehouse]);

  useEffect(() => {
    setPagination({
      ...pagination,
      total: returns.paginate?.items ? returns.paginate.items : 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [returns.paginate]);

  useEffect(() => {
    if (!firstLoad) {
      updateDataByPagination();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.rowsPerPage, pagination.page]);

  const redirectAdd = () => {
    navigate(`/repayments/new`, { replace: false });
  };

  const emptyRows =
    pagination.rowsPerPage -
    Math.min(
      pagination.rowsPerPage,
      pagination.total - pagination.page * pagination.rowsPerPage
    );
  const { order, orderBy } = props;

  const handleChangePage = (event: any, page: any) => {
    setPagination({
      ...pagination,
      page: ++page,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setPagination({
      ...pagination,
      rowsPerPage: event.target.value,
    });
  };

  const getSorting = (order: string, orderBy: any) => {
    return order === 'desc'
      ? (a: any, b: any) => desc(a, b, orderBy)
      : (a: any, b: any) => -desc(a, b, orderBy);
  };

  const desc = (a: any, b: any, orderBy: any) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  const submitFilterReturns = (values: any) => {
    if (values.key !== '' && values.name_value !== '') {
      setFilter(`&${values.key}=${values.name_value}`);
    } else {
      setFilter('');
    }
  };

  const sliceX = 0;
  const sliceY = pagination.rowsPerPage;

  return (
    <Layout>
      <Wrapper>
        <Grid className={classes.containerHeader} container item spacing={4}>
          <Grid item xs={12} sm={8} md={8} className={classes.button}>
            <SearchForm
              submitFilter={submitFilterReturns}
              fields={fieldsFilterListPermision}
              initialValues={initialValuesFilter}
              filter={'LOA'}
              valuesEstatus={valuesEstatus}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4} className={classes.button}>
            {allowCreate && (
              <Button
                size='medium'
                color='secondary'
                variant='contained'
                onClick={() => redirectAdd()}
              >
                Realizar devolución
                <Add />
              </Button>
            )}
          </Grid>
        </Grid>
        {!loading ? (
          <div>
            <div>
              <TableContainer component={Paper}>
                <Table aria-label='simple table'>
                  <TableHeader cellsList={headCellsLoans} />
                  <TableBody>
                    {stableSort(returns.rows, getSorting(order, orderBy))
                      .slice(sliceX, sliceY)
                      .map((row: any) => {
                        return <Row key={`key-row-${row.loan_id}`} row={row} />;
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 49 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <TablePagination
              rowsPerPageOptions={[10, 20, 50]}
              component='div'
              count={pagination.total}
              rowsPerPage={pagination.rowsPerPage}
              page={pagination.page - 1}
              labelRowsPerPage='Renglones por página'
              backIconButtonProps={{
                'aria-label': 'Anterior',
              }}
              nextIconButtonProps={{
                'aria-label': 'Siguiente',
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        ) : (
          <Loading />
        )}
      </Wrapper>
    </Layout>
  );
};
